import { BaseContainerModel } from '../../../base-container.model';
import {bl_del_logistic_hub_hdr_RowClass, bl_del_logistic_hub_link_RowClass} from '../../../../dbschema';

export class DeliveryLogisticHubHdrContainerModel extends BaseContainerModel {
    bl_del_logistic_hub_hdr: bl_del_logistic_hub_hdr_RowClass = new bl_del_logistic_hub_hdr_RowClass();
    bl_del_logistic_hub_links: bl_del_logistic_hub_link_RowClass[] = [];
}
